document.addEventListener("DOMContentLoaded", function () {
  const toggleButton = document.getElementById("toggle-description");
  const descriptionContent = document.getElementById("description-content");

  if (toggleButton && descriptionContent) {
    toggleButton.addEventListener("click", function () {
      if (descriptionContent.style.display === "block") {
        descriptionContent.style.display = "none";
      } else {
        descriptionContent.style.display = "block";
      }
    });
  } else {
    console.error("Toggle button or description content not found.");
  }
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".description-button").forEach(function (button) {
    button.addEventListener("click", function () {
      let content = this.nextElementSibling;
      if (content.style.display === "block") {
        content.style.display = "none";
      } else {
        content.style.display = "block";
      }
    });
  });
});